import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import {
    getCustomerConversionById,
    getCustomerConversionFollowListByCustomerConversionId,
    getCustomerConversionPublicById
} from '@/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'
import {getMessageRemindById, getMessageReviewById} from "@/api/message";

@Component({})
export default class HighSeasInfo extends Vue {
    culesInfoShow = false
    customerInfoShow = true
    operationShow = true
    id: number;
    infoData: any = ''
    // 跟进记录
    tableData = []
    page = 1
    limit = 20
    total = 0
    loading = false
    isReceive: any = ''
    informationListImg: any = []
    menuBtn = menuBtn
    activities = []
    types = ''
    type = ''
    status = ''
    logList = ''
    pageloading = false

    // created()
    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    // methods
    formatDate = formatDate



    async getMsgData(id) {
        this.pageloading = true
        await getMessageRemindById({id: id}).then((data: any)=>{
            this.infoData = data.result.messageRemindInfo
            this.logList = data.result.messageRemindInfo.customerConversionLogList
            this.tableData = data.result.messageRemindInfo.customerConversionFollowList
            this.pageloading = false
        }).catch(err=>{
            this.pageloading = false
        })

    }


    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


}
